import { getUrl, Post, Upload } from './customer-support'

export const getListTingboxCtv = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.filter'), body)
}

export const Detail = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.detail'), body)
}

export const cancelRecoupment = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.cancel'), body)
}
export const markAsRecouped = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.confirm'), body)
}
export const comfirmUpload = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.confirm-list-data'), body)
}

export const markAsPaid = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.confirm'), body)
}

export const createRecoupment = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.recoupment.create'), body)
}

export const exportExcelCtv = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.export-excel'), body, {
    responseType: 'blob',
  })
}
export const downloadTemplateExcel = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.download-template-excel'), body, {
    responseType: 'blob',
  })
}

export const downloadErrorExcel = async body => {
  return Post(getUrl('cnps.dfs.commission.policy.download-file-error'), body, {
    responseType: 'blob',
  })
}

export const UploadFile = async (formData, onUploadProgress) => {
  const url = getUrl('cnps.dfs.commission.policy.read-file-approve-policy')
  const results = await Upload(url, formData, onUploadProgress)
  return results
}
